export default {
    agency: "Agency",
    tkcn: "TKCN",
}
